import { useParams } from 'react-router';
import type { LEASING_URL_PARAMS } from '../utils/routes';

export function useLeasingUrlParams() {
  const params = useParams<LEASING_URL_PARAMS>();

  return {
    propertyIdOrUndefined: params.propertyId,
    propertyId: params.propertyId || '',

    leaseId: Number(params.leaseId),
    renewalId: params.renewalId ? Number(params.renewalId) : 0,

    viewType: params.viewType,
    nestedViewType: params.nestedViewType,
  };
}
